import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { getPriceCalendarActionCreators } from "./priceCalendarActionCreators";
import { connect } from "react-redux";
import Swiper from "swiper";

import { getNearbyAirports } from "../../shared/nearby-places-api";
import { getClassNames, groupByOp } from "../../shared/utils";
import { calendarAvailableLegs } from "../../shared/calendarAvailableLegs";

import ToggleSwitch from "./ToggleSwitch";
import CitySelector from "../CitySelector";
import PriceRange from "./PriceRange";
import Total from "./Total";
import MiniCalendar from "./MiniCalendar";
import Calendar from "./Calendar";
import Tooltip from "./Tooltip";

const winWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
const isMobile = winWidth < 768;
let range = n => [...Array(n).keys()];
export class PriceCalendar extends Component {
	constructor(props) {
		super(props);

		this.state = { goWarn: false };

		this.swiper = null;
		this.confirmTooltipTimeout = null;
		this.renderMessage = this.renderMessage.bind(this);
		this.renderPreloader = this.renderPreloader.bind(this);
		this.renderMinimapGroup = this.renderMinimapGroup.bind(this);
		this.renderCalendarGroup = this.renderCalendarGroup.bind(this);
		this.showMinimap = this.showMinimap.bind(this);
		this.renderLegs = this.renderLegs.bind(this);
		this.showGoWarn = this.showGoWarn.bind(this);
		this.renderFooter = this.renderFooter.bind(this);
		this.renderTopbar = this.renderTopbar.bind(this);
		this.getMostRankedMonth = this.getMostRankedMonth.bind(this);
		this.goToMonth = this.goToMonth.bind(this);
		this.reset = this.reset.bind(this);
	}

	renderMessage() {
		const { error, goIntent, backIntent, showMinimap, searchIntents, fetching } = this.props;

		let msg;
		if (error) msg = <p>{error}</p>;
		else if (!searchIntents && fetching) msg = null;
		else if (goIntent && backIntent) msg = <p>Data da ida e da volta selecionadas. Confirma?</p>;
		else if (goIntent)
			msg = (
				<p>
					Selecione a data da <strong>volta</strong>. Caso deseje apenas <strong>ida</strong>,{" "}
					<span className="visible-xs-inline visible-sm-inline">toque</span>
					<span className="hidden-xs hidden-sm">clique</span> em confirmar.
				</p>
			);
		else if (winWidth < 768 && !showMinimap)
			msg = (
				<p>
					Selecione a data de <strong>ida</strong>.
				</p>
			);
		else msg = <p>Escolha o mês em que deseja viajar e selecione as datas de ida e volta.</p>;

		return <div className="price-calendar__message">{msg}</div>;
	}

	renderPreloader() {
		if (!this.props.fetching) return null;

		return <div className="preloader" />;
	}

	renderMinimapGroup() {
		if (!this.props.showMinimap) return null;

		const { searchIntents, priceRange, toggleMinimap, tripType, goIntent, backIntent } = this.props;
		const months = range(6).map(i =>
			moment()
				.add(i, "month")
				.format("YYYY-MM")
		);

		const renderMiniCalendar = (month, i) => {
			const props = {
				toggleMinimap,
				priceRange,
				month,
				searchIntents,
				tripType,
				goToMonth: this.goToMonth,
				goIntent,
				backIntent,
				key: i
			};

			return <MiniCalendar {...props} />;
		};

		return <div className="price-calendar__minimap-group">{months.map(renderMiniCalendar)}</div>;
	}

	renderCalendarGroup() {
		const {
			searchIntents,
			priceRange,
			toggleMinimap,
			goIntent,
			backIntent,
			setGoIntent,
			setBackIntent,
			showMinimap,
			origin,
			destination,
			tripType,
			getPriceCalendar
		} = this.props;
		const { getMostRankedMonth, goToMonth } = this;
		if (showMinimap) return null;
		const months = range(6).map(i =>
			moment()
				.add(i, "month")
				.format("YYYY-MM")
		);

		const renderCalendar = (month, i) => {
			const props = {
				toggleMinimap,
				goIntent,
				backIntent,
				setGoIntent,
				setBackIntent,
				priceRange,
				month,
				origin,
				destination,
				searchIntents,
				tripType,
				getPriceCalendar,
				index: i,
				key: i
			};

			return <Calendar {...props} />;
		};

		const priceRangeProps = {
			goIntent,
			backIntent,
			tripType,
			range: priceRange,
			goToMonth,
			getMostRankedMonth
		};

		const renderMobileHeader = () => (
			<div className="price-calendar__calendar-group-header">
				{this.renderTopbar()}
				{this.renderToggleSwitch()}
				<PriceRange {...priceRangeProps} />
			</div>
		);

		const slider = !isMobile ? true : false;
		const arrows = (
			<div className="price-calendar__swiper-arrows">
				<button onClick={() => this.swiper.slidePrev()} className="swiper-button-prev">
					<i className="icon-arrow-down" />
				</button>
				<button onClick={() => this.swiper.slideNext()} className="swiper-button-next">
					<i className="icon-arrow-down" />
				</button>
			</div>
		);

		return (
			<div className="price-calendar__calendar-group">
				<div className="price-calendar__calendar-group-chunk price-calendar__calendar-group-chunk--search-results">
					<div className="price-calendar__slider-header">
						<div className="hidden-xs">{this.renderToggleSwitch()}</div>
						<div className="hidden-xs">
							<PriceRange {...priceRangeProps} />
						</div>
					</div>

					{isMobile ? renderMobileHeader() : ""}
					<div
						ref={node => (this.swiperNode = node)}
						className={`price-calendar__calendar-group-inner ${slider ? "swiper-container" : ""}`}
					>
						<div
							className={`price-calendar__calendar-group-results ${slider ? "swiper-wrapper" : ""}`}
						>
							{months.map(renderCalendar)}
						</div>
					</div>
					{slider ? arrows : ""}
				</div>
				<div className="price-calendar__calendar-group-chunk price-calendar__calendar-group-chunk--totals">
					<div className="price-calendar__footer-wrapper">{this.renderFooter()}</div>
				</div>
			</div>
		);
	}

	componentDidMount() {
		let { origin, destination } = this.props;

		const mostPopulars = [
			{
				city: "São Paulo",
				// iata: "SAO" // ENQUANTO A API NAO TEM AGRUPAMENTOS, MANTER ESTE COMENTADO
				iata: "CGH"
			},
			{
				city: "Rio de Janeiro",
				// iata: "RIO" // ENQUANTO A API NAO TEM AGRUPAMENTOS, MANTER ESTE COMENTADO
				iata: "SDU"
			}
		];

		const mountPopulars = () => {
			if (mostPopulars[0].city.toUpperCase() == destination.city.toUpperCase())
				this.props.getPriceCalendar({ ...this.props, origin: mostPopulars[1] });
			else this.props.getPriceCalendar({ ...this.props, origin: mostPopulars[0] });
		};

		const testeABNearbyPlaces = window.testeABNearbyPlaces;

		if (testeABNearbyPlaces) {
			mountPopulars();
		} else {
			if (origin) this.props.getPriceCalendar(this.props);
			else {
				getNearbyAirports({ max: 1 })
					.then(({ data: [origin] }) => {
						if (
							origin &&
							origin.city.toUpperCase().trim() !== destination.city.toUpperCase().trim()
						) {
							// origin.iata = origin.group || origin.iata;
							origin.iata = origin.iata;
							this.props.getPriceCalendar({ ...this.props, origin });
						} else mountPopulars();
					})
					.catch(mountPopulars);
			}
		}
	}

	componentDidUpdate({
		searchIntents: prevIntents,
		goIntent: prevGoIntent,
		backIntent: prevBackIntent
	}) {
		const { goIntent, backIntent } = this.props;
		const term = winWidth < 991 ? "toque" : "clique";
		if (goIntent && backIntent && !prevBackIntent)
			this.showGoWarn(`Datas de ida e volta selecionadas, ${term} aqui para prosseguir.`);
		else if (!prevGoIntent && goIntent)
			this.showGoWarn(`Caso deseje apenas ida, ${term} aqui para prosseguir.`);

		if (!prevIntents && this.swiperNode) {
			this.swiper = new Swiper(this.swiperNode, {
				simulateTouch: false,
				slidesPerView: 4,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				breakpoints: {
					1850: {
						slidesPerView: 2
					},
					1140: {
						slidesPerView: 2
					},
					767: {
						slidesPerView: 1
					}
				}
			});
		}
	}

	showMinimap() {
		const { toggleMinimap } = this.props;
		toggleMinimap(true);
		const el = document.querySelector(".price-calendar__calendar-group");
		if (!el) return null;
		el.scrollTo(0, 0);
	}

	renderLegs() {
		const { backIntent, goIntent } = this.props;

		return (
			<div className="price-calendar__legs">
				{goIntent ? (
					<div>
						<span>IDA:</span>{" "}
						<strong>
							{goIntent
								.split("-")
								.splice(1, 2)
								.reverse()
								.join("/")}{" "}
						</strong>
					</div>
				) : (
					""
				)}
				{backIntent ? (
					<div>
						<span>VOLTA:</span>{" "}
						<strong>
							{backIntent
								.split("-")
								.splice(1, 2)
								.reverse()
								.join("/")}{" "}
						</strong>
					</div>
				) : (
					""
				)}
			</div>
		);
	}

	showGoWarn(msg) {
		if (this.confirmTooltipTimeout) clearTimeout(this.confirmTooltipTimeout);
		this.confirmTooltipTimeout = setTimeout(() => this.setState({ goWarn: false }), 6000);
		this.setState({ goWarn: msg });
	}

	reset() {
		const { tripType } = this.props;
		this.props.reset();
		if (tripType === "RT")
			setTimeout(
				() => this.props.getPriceCalendar(this.props, { outbound: getDefaultGoIntent() }),
				0
			);
	}

	renderFooter() {
		const {
			fetching,
			tripType,
			goIntent,
			backIntent,
			origin,
			destination,
			searchIntents
		} = this.props;
		let props = {};

		if (origin && destination) {
			const str = getSearchUrl(goIntent, backIntent, origin.iata, destination.iata);
			if (str) props.href = str;
		}

		const ctaStyle = {};
		let ctaString = "Pesquisar";
		if (goIntent && backIntent) {
			ctaStyle.fontSize = "1rem";
			ctaStyle.lineHeight = "1.7rem";
			ctaString = "Pesquisar ida e volta";
		} else if (goIntent) ctaString = "Pesquisar voos de ida";

		return (
			<div className="price-calendar__footer">
				<div className="price-calendar__footer-row price-calendar__footer-row--info hidden-xs">
					<div className="origin-destination-card">
						<h3 className="hidden-xs hidden-sm hidden-md">Sua viagem</h3>
						<div className="origin-destination-card__inner">
							<div className="origin-destination-card__chunk">
								<div className="origin-destination-card__row">
									<span>Ida</span>
									<strong>
										{goIntent
											? goIntent
													.split("-")
													.slice(1, 3)
													.reverse()
													.join("/")
											: "-"}
									</strong>
								</div>
								{backIntent && (
									<div className="origin-destination-card__row">
										<span>Volta</span>
										<strong>
											{backIntent
												.split("-")
												.slice(1, 3)
												.reverse()
												.join("/")}
										</strong>
									</div>
								)}
							</div>
							<div className="origin-destination-card__chunk">
								<div className="origin-destination-card__row">
									<span>Origem</span>
									<strong>{origin ? origin.city : "-"}</strong>
								</div>
								<div className="origin-destination-card__row">
									<span>Destino</span>
									<strong>{destination ? destination.city : "-"}</strong>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="price-calendar__footer-row price-calendar__footer-row--main">
					<Total
						fetching={fetching}
						tripType={tripType}
						goIntent={goIntent}
						backIntent={backIntent}
						searchIntents={searchIntents}
					/>
					<div className="price-calendar__footer-buttons">
						<a {...props} target="_blank" className="price-calendar__confirm" style={ctaStyle}>
							{ctaString}
						</a>
						<button
							disabled={!goIntent ? "disabled" : ""}
							type="button"
							className="price-calendar__redefine"
							onClick={() => this.reset()}
						>
							Recomeçar
						</button>
					</div>
				</div>
			</div>
		);
	}

	renderTopbar() {
		if (this.props.fetching) return null;

		return (
			<div className="price-calendar__topbar">
				{this.renderLegs()}
				<button className="price-calendar__close" onClick={() => this.showMinimap(true)}>
					Fechar x
				</button>
			</div>
		);
	}

	getMostRankedMonth(rank) {
		const { searchIntents, priceRange, tripType } = this.props;
		const intentsByMonths = groupByOp(searchIntents, item => {
			const day = tripType === "RT" ? item["inbound"] : item["outbound"];
			return day
				.split("-")
				.slice(0, 2)
				.join("-");
		});
		let month, max;

		for (let prop in intentsByMonths) {
			if (!month) month = prop;

			let value = intentsByMonths[prop];
			let count = value.filter(item => getPriceRank(getSmallest(item), priceRange) == rank);

			if (!max) max = count;
			else {
				month = max >= count ? month : prop;
				max = max >= count ? max : count;
			}
		}

		return month;
	}

	goToMonth(month) {
		const { toggleMinimap } = this.props;
		toggleMinimap(false); // async

		if (isMobile) {
			setTimeout(() => {
				const el = document.querySelector(`[data-year-month="${month}"]`);
				if (!el) return null;
				el.parentNode.parentNode.scrollTo(0, el.offsetTop - 149);
			}, 0);
		} else {
			const node = document.querySelector(`[data-year-month="${month}"]`);
			const slideIndex =
				node && node.attributes["data-month-index"] ? node.attributes["data-month-index"].value : 0;
			this.swiper.slideTo(slideIndex);
		}
	}

	renderToggleSwitch() {
		const { tripTypeSwitch, tripType, toggleTripType, getPriceCalendar } = this.props;

		if (!tripTypeSwitch) {
			if (tripType == "OW") {
				return (
					<div className="price-calendar-no-switch">
						<p>
							<strong>Preço dos voos somente ida</strong>
						</p>
						<p>Escolha a data da sua viagem</p>
					</div>
				);
			} else {
				return;
			}
		}

		const props = {
			onText: "Ida e volta",
			offText: "Somente ida",
			value: tripType === "RT",
			handleChange: () => {
				toggleTripType();
				setTimeout(() => getPriceCalendar(this.props), 0); //gambi
			}
		};

		return <ToggleSwitch {...props} />;
	}

	render() {
		const {
			origin,
			destination,
			priceRange,
			showMinimap,
			getPriceCalendar,
			fetching,
			error,
			goIntent,
			backIntent,
			tripType
		} = this.props;

		const { goToMonth, getMostRankedMonth } = this;

		const classNames = getClassNames({
			"price-calendar": true,
			"minimap-is-open": showMinimap,
			error
		});

		const citySelectorCallback = origin => {
			getPriceCalendar({ ...this.props, goIntent: null, origin });
		};

		const cityFilter = city => {
			const str = `${city.iata}-${destination.iata}`;
			return calendarAvailableLegs.some(leg => leg.trecho == str);
		};

		const priceRangeProps = {
			goIntent,
			tripType,
			range: priceRange,
			goToMonth,
			getMostRankedMonth,
			backIntent
		};

		return (
			<section className={classNames}>
				<h2 className="price-calendar__header">
					Melhores dias para voar de{" "}
					<span className="position-relative d-inline-block">
						{origin && origin.fixed ? (
							`${origin.city} (${origin.iata})`
						) : (
							<div>
								<CitySelector selected={origin} callback={citySelectorCallback} />
								{error && <Tooltip msg={error} timestamp={new Date().getTime()} />}
							</div>
						)}
					</span>
					<span> para </span>
					<span style={{ whiteSpace: "nowrap" }}>
						{destination.city} ({destination.iata})
					</span>
				</h2>
				<div className="visible-xs">{this.renderToggleSwitch()}</div>
				<div className="visible-xs">
					<PriceRange {...priceRangeProps} />
				</div>
				<div className={`price-calendar__results ${fetching ? "fetching" : ""}`}>
					{this.renderPreloader()}
					{this.renderCalendarGroup()}
					{this.renderMinimapGroup()}
				</div>
			</section>
		);
	}
}

PriceCalendar.propTypes = {
	tripType: PropTypes.string,
	tripTypeSwitch: PropTypes.bool
};

PriceCalendar.defaultProps = {
	tripTypeSwitch: false
};

const mapStateToProps = state => state.priceCalendar;

const mapDispatchToProps = dispatch => getPriceCalendarActionCreators(dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PriceCalendar);

/* UTILS */

export const getIntentByDate = (date, searchIntents, returning) => {
	if (!date || !searchIntents) return null;
	const leg = returning ? "inbound" : "outbound";
	const matches = searchIntents.filter(item => item[leg] === date);

	if (!matches.length) return null;
	else return matches.reduce((prev, next) => (getSmallest(prev) < getSmallest(next) ? prev : next));
};

export const getSmallest = (item, { withTaxes = true, leg = "" } = {}) => {
	if (!item) return null;
	leg = leg || (item.type === "OW" ? "out" : "in");
	if (!item[`${leg}_miles_saleTotal`]) return null;
	const type = withTaxes ? "saleTotal" : "fareTotal";
	const reg = new RegExp(`${leg}_(ota|miles)_${type}`, "g");

	return Object.keys(item)
		.filter(prop => reg.test(prop))
		.map(prop => item[prop])
		.reduce((prev, next) => (prev < next ? prev : next));
};

export const getPriceRange = (searchIntents, isRoundTrip = false) => {
	const validMonths = range(6).map(i =>
		moment()
			.add(i, "month")
			.format("YYYY-MM")
	);
	const arr = searchIntents
		.filter(item => {
			const leg = item.type === "OW" ? "out" : "in";
			const date = item[`${leg}bound`];
			const month = date
				.split("-")
				.splice(0, 2)
				.join("-");
			return validMonths.some(item => item === month);
		})
		.filter(item => {
			const leg = item.type === "OW" ? "out" : "in";
			return item[`${leg}_miles_saleTotal`];
		})
		.sort((a, b) => {
			const aSmaller = isRoundTrip
				? getSmallest(a, { withTaxes: true, leg: "in" }) +
				  getSmallest(a, { withTaxes: true, leg: "out" })
				: getSmallest(a);
			const bSmaller = isRoundTrip
				? getSmallest(b, { withTaxes: true, leg: "in" }) +
				  getSmallest(b, { withTaxes: true, leg: "out" })
				: getSmallest(b);
			return aSmaller - bSmaller;
		}); // ordena pelo mais barato, independente de mm e airline

	const theBest = isRoundTrip
		? parseInt(
				getSmallest(arr[0], { withTaxes: true, leg: "in" }) +
					getSmallest(arr[0], { withTaxes: true, leg: "out" })
		  )
		: parseInt(getSmallest(arr[0]));

	const firstSmallDifferentFromTheBest = arr.find(item => parseInt(getSmallest(item)) !== theBest);
	const smallest = isRoundTrip
		? getSmallest(firstSmallDifferentFromTheBest, { withTaxes: true, leg: "in" }) +
		  getSmallest(firstSmallDifferentFromTheBest, { withTaxes: true, leg: "out" })
		: parseInt(getSmallest(firstSmallDifferentFromTheBest));

	const theLast = arr[arr.length - 1];
	const biggest = isRoundTrip
		? getSmallest(theLast, { withTaxes: true, leg: "in" }) +
		  getSmallest(theLast, { withTaxes: true, leg: "out" })
		: parseInt(getSmallest(theLast));

	const part = parseInt((biggest - smallest) / 3);

	const r0 = theBest;
	const r1 = smallest;
	const r2 = smallest + part;
	const r3 = smallest + part * 2;

	return [r0, r1, r2, r3];
};

export const getPriceRank = (price, priceRange) => {
	if (!price || priceRange === null || priceRange === undefined) return null;

	const intPrice = parseInt(price);
	if (intPrice < priceRange[1]) return 0;
	else if (intPrice < priceRange[2]) return 1;
	else if (intPrice < priceRange[3]) return 2;
	else return 3;
};

export const getSearchUrl = (goIntent, backIntent, originIata, destinationIata) => {
	if (!goIntent) return "";

	const goDate = goIntent;
	const tripType = backIntent ? "RT" : "OW";
	const backDate = backIntent ? `/${backIntent}` : "";
	const href = `https://maxmilhas.com.br/busca-passagens-aereas/${tripType}/${originIata}/${destinationIata}/${goDate}${backDate}/1/0/0/EC`;

	return href;
};

export const getDefaultGoIntent = () =>
	moment()
		.add(1, "days")
		.format("YYYY-MM-DD");
export const getDefaultBackIntent = goIntent =>
	moment(goIntent)
		.add(4, "days")
		.format("YYYY-MM-DD");
